import React, { useCallback, useState } from 'react';
import { useParams } from 'react-router';

import {
  useMerchandisingProgramQuoteSupportChats,
  usePostMerchandisingProgramQuoteSupportChat,
  useUpdateSupportChatFiles,
} from 'services/Data/SupportChatServices';
import SupportChatSharedContainer from './SupportChatSharedContainer';
import { BlobStorageTypeEnumValue } from 'enums/BlobStorageTypeEnum';
import SupportFileUploadModal from './SupportFileUploadModal';

const AssociatedMerchandisingProgramQuoteSupportChats = ({ disableSupportChat }) => {
  let { merchandisingProgramQuoteId } = useParams();

  const { data: supportChats, isFetching: gettingSupportChats } = useMerchandisingProgramQuoteSupportChats(
    merchandisingProgramQuoteId,
  );
  const {
    mutateAsync: postMerchandisingProgramQuoteSupportChat,
    isPending: isPostingMerchandisingProgramQuoteSupportChat,
  } = usePostMerchandisingProgramQuoteSupportChat();

  const { mutateAsync: uploadChatFiles } = useUpdateSupportChatFiles();
  const [files, setFiles] = useState([]);
  const [openUploadModal, setOpenUploadModal] = useState();

  const handleCloseUploadModal = useCallback(() => setOpenUploadModal(false), []);
  const handleOpenUploadModal = useCallback(() => setOpenUploadModal(true), []);
  const handleAddFile = useCallback(files => setFiles(prev => [...prev, ...files]), []);
  const handleResetFile = useCallback(() => setFiles([]), []);

  const handleRemoveFile = useCallback(fileToRemove => setFiles(prev => prev.filter(f => f.path !== fileToRemove.path)), []);

  const handleAddNewNote = useCallback(
    newNote => {
      postMerchandisingProgramQuoteSupportChat({
        note: newNote,
        merchandisingProgramQuote_Id: merchandisingProgramQuoteId,
      }).then(({ data: note }) => {
        uploadChatFiles({ files, entityId: note.id, type: BlobStorageTypeEnumValue.SupportChat }).then(_ => {
          handleResetFile();
        });
      });
    },
    [merchandisingProgramQuoteId, postMerchandisingProgramQuoteSupportChat, files, uploadChatFiles, handleResetFile],
  );

  return (
    <>
      <SupportFileUploadModal handleAddFile={handleAddFile} onClose={handleCloseUploadModal} show={openUploadModal} />
      <SupportChatSharedContainer
        fromProfile
        gettingSupportChats={gettingSupportChats}
        supportChats={supportChats}
        handleAddNewNote={handleAddNewNote}
        isPostingSupportChat={isPostingMerchandisingProgramQuoteSupportChat}
        disableSupportChat={disableSupportChat}
        openUploadFileModal={handleOpenUploadModal}
        files={files}
        handleRemoveFile={handleRemoveFile}
        handleResetFile={handleResetFile}
      />
    </>
  );
};

export default AssociatedMerchandisingProgramQuoteSupportChats;
